import Apollo from '@adoratorio/apollo';
import engine from '@/scripts/engine';

const apollo = {
  ref: null,

  init(DOMEelement) {
    this.ref = new Apollo({
      cursor: DOMEelement,
      detectTouch: false,
      easing: {
        mode: Apollo.EASING.CUBIC,
        duration: 400,
      },
      // initialPosition: { x: 0, y: 0 },
      props: [
        {
          id: 'r',
          target: DOMEelement.querySelector('circle'),
          key: 'r',
          suffix: '',
          type: Apollo.PROPERTY_TYPE.ATTRIBUTE,
          easing: {
            mode: Apollo.EASING.CUBIC,
            duration: 400,
          },
          initial: 60,
          precision: 2,
        },
      ],
      targets: [],
      aion: engine,
      emitGlobal: true,
    });
  },
};

export default apollo;
